import { render, staticRenderFns } from "./ReportActions.vue?vue&type=template&id=252b825c"
import script from "./ReportActions.vue?vue&type=script&lang=js"
export * from "./ReportActions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports